module.exports = __webpack_public_path__ + "img/SVGaccount.ed840b15.svg";